import React from 'react';
import Button from '@mui/material/Button';

export const ButtonK = (props) => {
  const { handleClick, color, backgroundColor, text, varient, width, sx } = props;

  return (
    <Button
      onClick={handleClick}
      variant={varient}
      sx={{
        marginTop: '10px',
        backgroundColor: backgroundColor,
      
        color: color,
        borderRadius: '8px',
        fontSize: varient === 'filled' ? '16px' : '12px',
        fontWeight: varient === 'filled' ? '600' : '600',
        width: width, // Use the width prop here
        ...sx, // Merge with external styles
        '&:hover': {
          backgroundColor: backgroundColor, // Keep the background color on hover
          color: color, // Keep the text color on hover
          borderRadius: '8px', // Keep the border radius on hover
          fontSize: varient === 'filled' ? '16px' : '12px', // Keep the font size on hover
          fontWeight: varient === 'filled' ? '600' : '600', // Keep the font weight on hover
          // Add any other styles you want to preserve on hover
        },
      }}
    >
      {text}
    </Button>
  );
};

export default ButtonK;
